import React, { useEffect, useState } from "react";

// Reader-set body text size for critique pages.
//
// Small, but it is one of the things a native reader expects and a web page
// does not offer: the choice is stored on the device and applied to every
// critique the reader opens afterwards. The scale is written onto <html> as a
// data attribute so a single CSS rule can size the body copy.

const KEY = "btn-reading-size";
const SIZES = ["s", "m", "l", "xl"];
const LABELS = { s: "A", m: "A", l: "A", xl: "A" };
const TITLES = {
  s: "Small text",
  m: "Default text size",
  l: "Large text",
  xl: "Largest text",
};

export function readSize() {
  try {
    const v = localStorage.getItem(KEY);
    return SIZES.includes(v) ? v : "m";
  } catch (e) {
    return "m";
  }
}

export function applySize(size) {
  try {
    document.documentElement.setAttribute("data-reading-size", size);
  } catch (e) {}
}

// Called once at start-up so a reader's choice survives a relaunch.
export function initReadingSize() {
  applySize(readSize());
}

function ReadingSize() {
  const [size, setSize] = useState(readSize);

  useEffect(() => {
    applySize(size);
    try {
      localStorage.setItem(KEY, size);
    } catch (e) {}
  }, [size]);

  return (
    <div className="reading-size" role="group" aria-label="Text size">
      <span className="reading-size-label">Text size</span>
      {SIZES.map((s) => (
        <button
          key={s}
          className={`reading-size-btn size-${s} ${size === s ? "active" : ""}`}
          onClick={() => setSize(s)}
          title={TITLES[s]}
          aria-pressed={size === s}
        >
          {LABELS[s]}
        </button>
      ))}
    </div>
  );
}

export default ReadingSize;
